import React from "react";
import { Card, Divider } from "antd";
import { USABLE_ICONS, MODULE_APPROVAL_AWARDS } from "variables/constants";
import ApprovalButtons from "components/button/approvalbuttons";
import AwardApprovalForm from "../../approval-awards/components/AwardApprovalForm";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

const MyNominationCard = ({ recordList }) => {
  const authUser = useSelector((state) => state.auth.user);

  return (
    <>
      {recordList?.map((item) => {
        const colorClass = item?.award_color_class?.toLowerCase();

        const IconComponent =
          item?.award_icon && USABLE_ICONS[item.award_icon]
            ? USABLE_ICONS[item.award_icon]
            : null;


        return (
          <Card
            key={item?.ema_id}
            className={`rounded-2xl overflow-y-auto pr-2 mb-2 nomination dark-mode-card ${colorClass || ""}`}
          >
            <div className="relative flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3">
              <span
                className={`absolute top-0 right-0 sm:right-5 text-white p-2 icon-style ${colorClass || ""}`}
              >
                {IconComponent &&
                  React.createElement(IconComponent, {
                    className: "h-5 w-5"
                  })}
                  
              </span>

              <div className="flex items-start gap-3 min-w-0 pr-20">

                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-full bg-green-100 text-green-700 font-semibold">
                  {item?.employee_initials}
                </div>

                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">

                    <h4 className="font-semibold text-base title-text break-words leading-tight">
                      {item?.employee_name}
                    </h4>

                    <span className="status-indicator normal text-[10px] muted-text">
                      {item?.employee_code}
                    </span>

                    <span className={`status-indicator ${item?.ema_status_name.toLowerCase()} text-[10px] px-2`}>
                      {item?.ema_status_name}
                    </span>

                  </div>

                  <p className="text-gray-600 text-[13px]">
                    Nominated by: {item?.nominator_name || "System"}
                  </p>
                </div>
              </div>
            </div>

            <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
              <div className="col-span-2 sm:col-span-1">
                <p className="text-base mb-1 muted-text">
                  Award Category
                </p>
                <div className="text-base font-medium title-text">
                  {item?.award_title}
                </div>
              </div>

              <div className="col-span-2 sm:col-span-1 flex flex-col">
                <p className="text-base text-gray-500 mb-1">
                  Nomination Date
                </p>
                <div className="text-base font-medium title-text">
                  {item?.ema_issued_at
                    ? dayjs(item.ema_issued_at).format("MMMM D, YYYY")
                    : "-"}
                </div>
                {item?.ema_status_name?.toLowerCase() === 'pending' && 
                  !authUser?.client_id && (
                  <div className="mt-6 flex justify-end">
                    <ApprovalButtons
                      record={item}
                      recordIdKey="ema_id"
                      employeeNameKey="employee_name"
                      moduleId={MODULE_APPROVAL_AWARDS} 
                      FormComponent={AwardApprovalForm}
                      modalPrefix="edit_nomination"
                    />
                  </div>
                )}
              </div>
              
            </div>
          </Card>
        );
      })}
    </>
  );
};

export default MyNominationCard;